exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3zgwz-7_3_0 {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  box-shadow: -4px 0px 5px 0px rgba(112, 112, 112, 0.1);\n  background-color: #ffffff; }\n  ._31OWX-7_3_0 {\n    background-color: #f5f5f5;\n    transition: background-color 0.2s ease-in-out; }\n    ._6_LFq-7_3_0:hover {\n      background-color: #d9d9d9; }\n  ._2z3Tc-7_3_0 {\n    text-align: left;\n    padding: 16px;\n    line-height: 13px; }\n  .LLy8E-7_3_0 {\n    border-top: 1px solid #d9d9d9;\n    transition: background-color 0.2s ease-in-out; }\n  .-EXvf-7_3_0 {\n    padding: 16px;\n    line-height: 13px; }\n", ""]);

// Exports
exports.locals = {
	"core-table-shelf": "_3zgwz-7_3_0",
	"core-table-shelf__head": "_31OWX-7_3_0",
	"core-table-shelf__head--hoverable": "_6_LFq-7_3_0",
	"core-table-shelf__th": "_2z3Tc-7_3_0",
	"core-table-shelf__body-row": "LLy8E-7_3_0",
	"core-table-shelf__td": "-EXvf-7_3_0"
};